import { Container } from "@mui/material";
import { AddMaterial } from "../Roofs/AddMaterial";
import { FC, useState } from "react";
import { Material } from "../../../../redux/types/Material";
import { FlashTable } from "./FlashTable";

interface GuttersProps {
  onDone: Function;
  materials?: Material[];
}

export const FlashingMaterials: FC<GuttersProps> = ({ onDone, materials }) => {
  const [addMaterial, setAddMaterial] = useState(false);

  const onDisplayAddMaterial = () => {
    setAddMaterial(!addMaterial);
  };

  if (addMaterial) {
    return (
      <Container>
        <AddMaterial
          matType="flashing"
          onCancel={() => setAddMaterial(false)}
          onTapAdd={() => {
            setAddMaterial(false);
            onDone("flashing");
          }}
        />
      </Container>
    );
  } else {
    return (
      <FlashTable
        materials={Array.isArray(materials) ? materials : []}
        onUploadFlashing={() => onDisplayAddMaterial()}
      />
    );
  }
};
